// extracted by mini-css-extract-plugin
export var afterConfirmTextContainer = "AfterConfirmText_afterConfirmTextContainer__wj6ja";
export var md = "768px";
export var shared = "'../../../shared.module.css'";